"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class MetricsClientV2 extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.formatDateWithTimezone = true;
    }
    getMetrics(projectId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/metrics`, body);
            return response.payload;
        });
    }
    getChart(projectId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/metrics/chart`, body);
            return response.payload;
        });
    }
    getSiteOverviewMetrics(ac) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${ac.project}/metrics/site-overview`;
            const body = {
                from: ac.from,
                to: ac.to,
                goal: ac.goal,
                segment: ac.segment,
                device: ac.device,
                toCurrency: ac.toCurrency,
            };
            const response = yield this.httpPost(url, body);
            response.payload.conversions.forEach(i => (i.day = new Date(i.day)));
            return response.payload;
        });
    }
    getImpactMetrics(ac) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${ac.project}/metrics/impact`;
            const body = {
                from: ac.from,
                to: ac.to,
                goal: ac.goal,
                segment: ac.segment,
                device: ac.device,
                toCurrency: ac.toCurrency,
            };
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getExposures(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = __rest(request, ["project"]);
            const url = `/v2/projects/${project}/metrics/exposures`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getZoningMetrics(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = __rest(request, ["project"]);
            const url = `/v2/projects/${project}/metrics/zoning`;
            const response = yield this.httpPost(url, body);
            return response.payload || [];
        });
    }
    getZonesMetrics(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryString = Array.isArray(request.metrics) ? { metrics: request.metrics } : { metricType: request.metrics };
            delete request.metrics;
            const url = `/v2/projects/${request.project}/metrics/zones?` + this.getQueryString(queryString);
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getPageViews(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = __rest(request, ["project"]);
            const url = `/v2/projects/${project}/metrics/total-views`;
            const response = yield this.httpPost(url, body);
            return {
                pageId: request.pageId || request.aliasId,
                urlRegex: request.urlRegex,
                totalViews: response.payload ? response.payload.totalViews : null,
            };
        });
    }
    getPageMetrics(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = __rest(request, ["project"]);
            const url = `/v2/projects/${request.project}/metrics/page`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPagesMetrics(ac) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${ac.project}/metrics/pages`;
            const body = {
                from: ac.from,
                to: ac.to,
                goal: ac.goal,
                segment: ac.segment,
                device: ac.device,
                metrics: ac.metrics,
                pages: ac.pages,
                urlRegexes: ac.urlRegexes,
            };
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getFoldHeight(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = __rest(request, ["project"]);
            const url = `/v2/projects/${request.project}/metrics/foldheight`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getBrowsers(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${request.project}/metrics/search-browsers?from=${request.from}` +
                `&to=${request.to}&deviceId=${request.deviceId}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getPlatforms(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${request.project}/metrics/search-platforms?from=${request.from}` +
                `&to=${request.to}&deviceId=${request.deviceId}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getNavigationTree(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = __rest(request, ["project"]);
            const url = `/v2/projects/${request.project}/metrics/navigation-path`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getStats(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `/v2/projects/${projectId}/segments/stats`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTraffic(projectId, segment, from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/segments/traffic`;
            const response = yield this.httpPost(url, { from, to, segment });
            return response.payload;
        });
    }
    getTrafficDistribution(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `/v2/projects/${projectId}/metrics/traffic/distribution`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getMissToWin(missToWinModel) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${missToWinModel.project}/segments/misstowin`, missToWinModel);
            return response.payload;
        });
    }
    getFormStats(projectId, segments, from, to, device) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/segments/form-stats`;
            const response = yield this.httpPost(url, { from, to, device, segments });
            return response.payload;
        });
    }
}
exports.MetricsClientV2 = MetricsClientV2;
//# sourceMappingURL=metrics.client.v2.js.map